import { Component, OnInit } from '@angular/core';
import { RoblexCollapsedSidepanelRef } from '../../config';
import { RoblexCollapsedSidepanelConfig } from '../../config/collapsed-sidepanel/collapsed-sidepanel.config';
import { Dropdown, Menu } from '../../interfaces';

@Component({
    selector: 'roblex-header-collapsed-sidepanel',
    templateUrl: './header-collapsed-sidepanel.component.html',
    styleUrls: ['./header-collapsed-sidepanel.component.scss'],
})
export class HeaderCollapsedSidepanelComponent implements OnInit {
    /**
     * Menus  of header collapsed sidepanel component
     */
    menus: Menu[];
    /**
     * Dropdows  of header collapsed sidepanel component
     */
    dropdows: Dropdown[];
    /**
     * Creates an instance of header collapsed sidepanel component.
     * @param roblexCollapsedSidepanelConfig RoblexCollapsedSidepanelConfig
     */
    constructor(
        private roblexCollapsedSidepanelConfig: RoblexCollapsedSidepanelConfig,
        private roblexCollapsedSidepanelRef: RoblexCollapsedSidepanelRef
    ) {
        //
    }
    /**
     * on init
     */
    ngOnInit(): void {
        this.menus = this.roblexCollapsedSidepanelConfig.data.menus;
        this.dropdows = this.roblexCollapsedSidepanelConfig.data.dropdows;
    }
    /**
     * Determines whether click path on
     */
    onClickMenu(item: Menu) {
        if (item?.isRouteActive) {
            item?.isRouteActive(item);
        }

        if (item?.callbackAction) {
            item?.callbackAction(item);
        }

        this.roblexCollapsedSidepanelRef.close();
    }

    onClickDropdown(item: Dropdown) {
        if (item?.callbackAction) {
            item?.callbackAction(item);
        }

        this.roblexCollapsedSidepanelRef.close();
    }
}
